import { render, staticRenderFns } from "./url-modal.vue?vue&type=template&id=5ed12ab2&scoped=true&"
import script from "./url-modal.vue?vue&type=script&lang=ts&"
export * from "./url-modal.vue?vue&type=script&lang=ts&"
import style0 from "./url-modal.vue?vue&type=style&index=0&id=5ed12ab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed12ab2",
  null
  
)

export default component.exports